import { uuidGenerator } from '../../helper'
import { jwtGetGroup, jwtGetRoles } from '../../helper/jwt'
import axios from 'axios'
import { localStorageApi } from '../../helper/localStorageApi'
import { getCookieAccessToken } from '../../helper/cookieToken'

const circularSafeReplacer = () => {
	const seen = new WeakSet()
	return (key, value) => {
		if (typeof value !== 'object' || value === null) return value
		if (seen.has(value)) return '[Circular]'
		seen.add(value)
		return value
	}
}

const stringifyCircularSafe = value => {
	try {
		return JSON.stringify(value, circularSafeReplacer())
	} catch {
		return String(value)
	}
}

const stringify = value => {
	try {
		return JSON.stringify(value)
	} catch {
		return stringifyCircularSafe(value)
	}
}

const serializeValue = value => {
	if (typeof value === 'string') return value
	if (value instanceof Error) {
		return stringify({ ...value, name: value.name, message: value.message, stack: value.stack })
	}
	return stringify(value)
}

export const logToMezmo = async (data, level) => {
	const apiKey = 'b73b589f7ac94450a14f8c4ec08de475'
	const accessToken = getCookieAccessToken()
	const meta = {
		companyIndex: localStorageApi.getItem('companyIndex'),
		login: localStorageApi.getItem('login'),
		group: accessToken ? jwtGetGroup(accessToken) : null,
		roles: accessToken ? jwtGetRoles(accessToken) : null,
		deviceId: localStorageApi.getItem('desktopDeviceId') || uuidGenerator(),
		deviceType: navigator.userAgent,
		deviceSize: { width: window.screen.availWidth, height: window.screen.availHeight },
		env: window.location.host === 'app.liefersoft.de' ? 'live' : 'dev',
		version: window.REACT_APP_VERSION,
		versionDate: window.REACT_APP_VERSION_DATE,
	}
	const now = new Date().getTime()
	const env = window.location.host === 'app.liefersoft.de' ? 'live' : 'dev'
	return axios.post(`https://logs.mezmo.com/logs/ingest?hostname=${env}&mac=&ip=&tags=&now=${now}`, {
		e: 'ls',
		ls: [{
			app: 'liefersoft',
			level,
			line: data.map(serializeValue).join(' '),
			meta,
			timestamp: now,
		}],
	}, {
		auth: { username: apiKey, password: '' },
	})
}
